import { PaywallChargeBadge } from "@circle-react-shared/Paywalls/PaywallChargeBadge";

export const StatusColumn = (cellContext: any) => {
  const {
    row: { original: charge },
  } = cellContext;

  return <PaywallChargeBadge status={charge?.display_status} />;
};
